var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationNavigation = function SvgLocationNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.555 7.582 4.332.881a.83.83 0 0 1 .65.65l.88 4.332L15.35 4.65 6.555 7.582Zm5.667 9.918a.834.834 0 0 1-.818-.667l-1.39-6.847-6.847-1.392a.832.832 0 0 1-.098-1.607l13.333-4.444a.835.835 0 0 1 1.055 1.054l-4.445 13.334a.833.833 0 0 1-.79.569Z",
    fill: "#008545"
  })));
};
export default SvgLocationNavigation;